import React from "react";

import { toClassName } from "@src/multiCustodian/utils/to-class-name";

import styles from "./FormBody.module.css";

interface FormBodyProps {
  className?: string;
  columnCount?: number;
}

const FormBody: React.FC<React.PropsWithChildren<FormBodyProps>> = ({
  children,
  className,
  columnCount = 2,
}) => {
  return (
    <div
      className={toClassName(styles.container, className)}
      style={{ gridTemplateColumns: `repeat(${columnCount}, 1fr)` }}
    >
      {children}
    </div>
  );
};

export default FormBody;
